import { render, staticRenderFns } from "./StaffSearchSlidebar.vue?vue&type=template&id=4da10eb7"
import script from "./StaffSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./StaffSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports